'use strict';

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncIterator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _awaitAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var batch = require('it-batch');

function balanced(_x, _x2, _x3) {
  return _balanced.apply(this, arguments);
}

function _balanced() {
  _balanced = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source, reduce, options) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return reduceToParents(source, reduce, options);

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _balanced.apply(this, arguments);
}

function reduceToParents(_x4, _x5, _x6) {
  return _reduceToParents.apply(this, arguments);
}

function _reduceToParents() {
  _reduceToParents = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(source, reduce, options) {
    var roots, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunked;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            roots = [];
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context2.prev = 3;
            _iterator = _asyncIterator(batch(source, options.maxChildrenPerNode));

          case 5:
            _context2.next = 7;
            return _iterator.next();

          case 7:
            _step = _context2.sent;
            _iteratorNormalCompletion = _step.done;
            _context2.next = 11;
            return _step.value;

          case 11:
            _value = _context2.sent;

            if (_iteratorNormalCompletion) {
              _context2.next = 22;
              break;
            }

            chunked = _value;
            _context2.t0 = roots;
            _context2.next = 17;
            return reduce(chunked);

          case 17:
            _context2.t1 = _context2.sent;

            _context2.t0.push.call(_context2.t0, _context2.t1);

          case 19:
            _iteratorNormalCompletion = true;
            _context2.next = 5;
            break;

          case 22:
            _context2.next = 28;
            break;

          case 24:
            _context2.prev = 24;
            _context2.t2 = _context2["catch"](3);
            _didIteratorError = true;
            _iteratorError = _context2.t2;

          case 28:
            _context2.prev = 28;
            _context2.prev = 29;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context2.next = 33;
              break;
            }

            _context2.next = 33;
            return _iterator.return();

          case 33:
            _context2.prev = 33;

            if (!_didIteratorError) {
              _context2.next = 36;
              break;
            }

            throw _iteratorError;

          case 36:
            return _context2.finish(33);

          case 37:
            return _context2.finish(28);

          case 38:
            if (!(roots.length > 1)) {
              _context2.next = 40;
              break;
            }

            return _context2.abrupt("return", reduceToParents(roots, reduce, options));

          case 40:
            return _context2.abrupt("return", roots[0]);

          case 41:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 24, 28, 38], [29,, 33, 37]]);
  }));
  return _reduceToParents.apply(this, arguments);
}

module.exports = balanced;